// import { DragDropContext, DragDropContextProvider } from "react-dnd";
// import HTML5Backend from "react-dnd-html5-backend";

// 使用DragDropContextProvider方式，可以传window（事件生效的dom）
// export default function(C, selector) {
//     return function(props) {
//         return <DragDropContextProvider backend={HTML5Backend} window={document.querySelector(selector)}>
//             <C {...props}></C>
//         </DragDropContextProvider>
//     }
// }
// export default DragDropContext(HTML5Backend);
import platform from "Pub/js/platform";
const { base } = platform ;
const { NCDndDropContext } = base;
export default NCDndDropContext;
